import * as React from 'react';
import { Flex, genesisStyled, css } from '@leagueplatform/genesis-commons';
import { useIntl } from '@leagueplatform/locales';
import {
  PillTabs,
  PillTabList,
  PillTab,
} from '@leagueplatform/web-common-components';
import { track } from '@leagueplatform/analytics';
import { useParamsLegacy as useParams } from '@leagueplatform/routing';
import { CHART_VIEWS } from '#components/charts/constants/chart-views.ts';
import { Box } from '@leagueplatform/genesis-core';

const ViewSwitcherContainer = genesisStyled(Flex)(
  css({
    marginTop: '-30px',
  }),
);

type WeekMonthViewSwitchProps = {
  onChange: (view: string) => void;
};

const handleAnalyticsClick = (metricType: string, detail: string) =>
  track(
    'dashboard.button_clicked.metric_item_metric_type.navigate_to_metric_tab',
    {
      metric_type: metricType,
      detail,
      metric_id: '',
      metric_status: '',
      content_id: '',
      contentful_system: '',
    },
  );

export function WeekMonthViewSwitch({ onChange }: WeekMonthViewSwitchProps) {
  const { formatMessage } = useIntl();
  const { dataType } = useParams<{ dataType: string }>();

  return (
    <ViewSwitcherContainer>
      <PillTabs onValueChange={onChange} defaultValue={CHART_VIEWS.WEEKLY}>
        <Box css={{ width: 'fit-content' }}>
          <PillTabList>
            <PillTab
              value={CHART_VIEWS.WEEKLY}
              onClick={() => handleAnalyticsClick(dataType, 'last 7 days')}
            >
              {formatMessage({
                id: 'LAST_7_DAYS',
              })}
            </PillTab>
            <PillTab
              value={CHART_VIEWS.MONTHLY}
              onClick={() => handleAnalyticsClick(dataType, 'last 30 days')}
            >
              {formatMessage({
                id: 'LAST_30_DAYS',
              })}
            </PillTab>
          </PillTabList>
        </Box>
      </PillTabs>
    </ViewSwitcherContainer>
  );
}
